export { default } from './GatsbyAnchor';
